import { render, staticRenderFns } from "./RedpackEffect.vue?vue&type=template&id=0b732359&scoped=true&"
import script from "./RedpackEffect.vue?vue&type=script&lang=js&"
export * from "./RedpackEffect.vue?vue&type=script&lang=js&"
import style0 from "./RedpackEffect.vue?vue&type=style&index=0&id=0b732359&prod&lang=scss&scoped=true&"
import style1 from "./RedpackEffect.vue?vue&type=style&index=1&id=0b732359&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b732359",
  null
  
)

export default component.exports